import { render, staticRenderFns } from "./WidgetDocumentsByCreationDate.vue?vue&type=template&id=7499c8ca&"
import script from "./WidgetDocumentsByCreationDate.vue?vue&type=script&lang=js&"
export * from "./WidgetDocumentsByCreationDate.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDocumentsByCreationDate.vue?vue&type=style&index=0&id=7499c8ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports